import commonBaseSetBackgroundUrl from './assets/common-base-set/background.webp';
import winterBackgroundUrl from './assets/winter/background.webp';
import winterLeftUrl from './assets/winter/freeze-left.webp';
import winterRightUrl from './assets/winter/freeze-right.webp';

type BackgroundStyle = Pick<
  React.CSSProperties,
  'background' | 'backgroundBlendMode'
>;

const winterBackground: BackgroundStyle = {
  background: `
    url("${winterLeftUrl}") left center / contain no-repeat,
    url("${winterRightUrl}") right center / contain no-repeat,
    url("${winterBackgroundUrl}") center / cover no-repeat
  `,
  backgroundBlendMode: 'color-dodge, color-dodge, normal',
};

const commonBaseSetBackground: BackgroundStyle = {
  background: `
    linear-gradient(0deg, rgba(0, 0, 0, 0.50) 0%, rgba(0, 0, 0, 0.50) 100%),
    linear-gradient(0deg, #5776FF 0%, #5776FF 100%),
    url("${commonBaseSetBackgroundUrl}") center / cover repeat
  `,
  backgroundBlendMode: 'normal, hue, normal',
};

export const getBackground = (name?: string): BackgroundStyle => {
  switch (name) {
    case 'winter':
      return winterBackground;
    case 'common-base-set':
      return commonBaseSetBackground;
    default:
      return {};
  }
};
